import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type CategoryCardActionsProps = {
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onClone?: () => void;
  viewTarget: string;
  editTarget?: string;
  children: ReactNode;
  className?: string;
};

const CategoryCardActions = ({ children, className = "category-name", onView, onEdit, onDelete, onClone, viewTarget, editTarget }: CategoryCardActionsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={className}>
        {children}
        <div className="category-name-action category-card-hover-actions">
          <button className="btn-icon" type="button" data-bs-toggle="offcanvas" data-bs-target={viewTarget} onClick={onView} aria-label={t("btn_view")}><i className="ti ti-eye" /></button>
          <button className="btn-icon" type="button" data-bs-toggle={editTarget ? "offcanvas" : undefined} data-bs-target={editTarget} onClick={onEdit} aria-label={t("btn_edit")}><i className="ti ti-edit" /></button>
          {onClone && <button className="btn-icon" type="button" onClick={onClone} aria-label={t("clone_item_label")}><i className="ti ti-copy" /></button>}
          <button className="btn-icon" type="button" onClick={onDelete} aria-label={t("btn_delete")}><i className="ti ti-trash" /></button>
        </div>
      </div>
      <div className="category-card-actions dropdown">
        <button className="btn btn-icon dropdown-toggle category-card-menu-trigger" type="button" data-bs-toggle="dropdown" aria-expanded="false" aria-label={t("label_actions")}>
          <i className="ti ti-dots-vertical" />
        </button>
        <ul className="dropdown-menu">
          <li><button className="dropdown-item" type="button" data-bs-toggle="offcanvas" data-bs-target={viewTarget} onClick={onView}><i className="ti ti-eye" /> {t("btn_view")}</button></li>
          <li><button className="dropdown-item" type="button" data-bs-toggle={editTarget ? "offcanvas" : undefined} data-bs-target={editTarget} onClick={onEdit}><i className="ti ti-edit" /> {t("btn_edit")}</button></li>
          {onClone && <li><button className="dropdown-item" type="button" onClick={onClone}><i className="ti ti-copy" /> {t("clone_item_label")}</button></li>}
          <li><button className="dropdown-item" type="button" onClick={onDelete}><i className="ti ti-trash" /> {t("btn_delete")}</button></li>
        </ul>
      </div>
    </>
  );
};

export default CategoryCardActions;
